export const DomesticOrForeignEnum = {
    Domestic: 1,
    Foreign: 2
};